export const SUBMISSION = "submission";
export const SCRUBBER = "scrubber";
export const UPDATE = "UPDATE";
export const ROLE_NAME = "userRole";
export const CURRENT_TENANT = "currentTenant";
export const JUNIOR_UNDERWRITER = "junior underwriter";
export const SENIOR_UNDERWRITER = "senior underwriter";

export const APPLICATION_STATUS = {
  SUBMISSION: "Submission",
  SCRUBBING: "Scrubbing",
  UNDERWRITING: "Underwriting",
  OFFER_OUT: "Offer Out",
  DOC_REQUEST: "Pending Docs",
  DEAL_READY: "Pending Signed Docs",
  MERCHANT_INTERVIEW: "Pending Merchant Interview",
  PENDING_FINAL_APPROVAL: "Pending Final Approval",
  APPROVED: "Approved",
  DRAFT: "Draft",
};
